var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n    col-span-full\n    grid grid-cols-1\n    gap-4\n    md:grid-cols-2\n    lg:grid-cols-3\n    pb-4\n    mt-8\n  "},[_c('Content',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.wrapperLoading),expression:"wrapperLoading"}],staticClass:"col-span-full",attrs:{"title":_vm.$route.name,"router":{
      name: 'HISTORY_ROUTES',
    }}},[_c('RoutingMap',{attrs:{"tripDetail":_vm.tripDetails}})],1),(_vm.tripDetails != null)?_c('Content',{staticClass:"col-span-full",attrs:{"title":"SPEED_GRAPH","showBreadcrumb":false,"showAdd":false}},[_c('VueApexCharts',{attrs:{"type":"line","height":"350","options":{
        chartOptions: _vm.chartOptions,
        labels: _vm.date,
        annotations: {
          yaxis: [
            {
              y: _vm.tripDetails.max_speed,
              borderColor: '#b30000',

              label: {
                borderColor: '#b30000',
                textAnchor: 'start',
                style: {
                  color: '#fff',
                  background: '#b30000',
                },
                text: ((_vm.$t('MAX_SPEED')) + ": " + (_vm.tripDetails.max_speed) + "km/h"),
              },
            },
            {
              y: _vm.tripDetails.avg_speed,
              borderColor: '#d0aa00',
              label: {
                borderColor: '#d0aa00',
                textAnchor: 'start',
                style: {
                  color: '#fff',
                  background: '#d0aa00',
                },
                text: ((_vm.$t('AVG_SPEED')) + ": " + (_vm.tripDetails.avg_speed) + "km/h"),
              },
            } ],
        },
        points: [
          {
            x: new Date('01 Dec 2017').getTime(),
            y: _vm.tripDetails.max_speed,
            marker: {
              size: 8,
              fillColor: '#fff',
              strokeColor: 'red',
              radius: 2,
              cssClass: 'apexcharts-custom-class',
            },
            label: {
              borderColor: '#FF4560',
              offsetY: 0,
              style: {
                color: '#fff',
                background: '#FF4560',
              },

              text: 'Point Annotation',
            },
          } ],
      },"series":_vm.speeds}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }